export default __webpack_public_path__ + "static/media/active.aaff7339.svg";